module.exports = __webpack_public_path__ + "04054c0d217b85ac3387e676444c50c7.mp4";